import { IGeocodeState, EGeocodeStatus } from '../../../types/filters';

export const defaultState: IGeocodeState = {
  status: EGeocodeStatus.Initial,
};
